import { IGetChecklistEntregaAmbienteByIdUseCase } from "../../../presentation/useCases/read/get_checklist_entrega_ambiente_by_id_use_case";
import { ChecklistEntregaAmbienteModel } from "../../models/checklist_entrega_ambiente";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetChecklistEntregaAmbienteByIdUseCase
 */

export class GetChecklistEntregaAmbienteByIdUseCase implements IGetChecklistEntregaAmbienteByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntregaAmbiente: number
  ): Promise<ChecklistEntregaAmbienteModel> {
    const checklistEntregaAmbiente = await this.repository.getChecklistEntregaAmbienteById(idChecklistEntregaAmbiente);
    return checklistEntregaAmbiente;
  }
}
